export const QUOTE_REFRESH_INTERVAL_MS = 30_000;
export const SENDING_REFRESH_INTERVAL_MS = 3_000;
